<template>
    <v-app style="background-color:#f0f0f0;">
        <transition mode="out-in">
            <router-view />
        </transition>
        <the-snackbar />
    </v-app>
</template>

<script>
export default {
    name: 'App',
    components: {
        'the-snackbar': () => import('@/components/TheSnackbar.vue')
    }
};
</script>
